import React from 'react';
import { MapPin } from 'lucide-react';
import { floridaCities } from '../../data/mock';

const FloridaCoverage = () => {
  return (
    <section id="coverage" className="relative py-24 lg:py-32 bg-[#050505]">
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#00D4FF] text-sm font-semibold tracking-wider uppercase mb-4 block">
            Coverage Area
          </span>
          <h2 className="text-3xl lg:text-5xl font-bold text-white mb-6">
            Serving All of Florida
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed">
            Our armed security officers are strategically positioned across Florida's
            major metropolitan areas for rapid deployment.
          </p>
        </div>

        {/* Map-style layout */}
        <div className="relative">
          {/* Florida shape silhouette (simplified) */}
          <div className="relative bg-gradient-to-br from-white/[0.03] to-transparent border border-white/10 p-8 lg:p-12">
            {/* Grid of cities */}
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
              {floridaCities.map((city, index) => (
                <div
                  key={city}
                  className="group flex items-center gap-3 p-4 bg-black/50 border border-white/5 hover:border-[#00D4FF]/50 hover:bg-[#00D4FF]/5 transition-all duration-300 cursor-pointer"
                >
                  <MapPin className="w-4 h-4 text-[#00D4FF] flex-shrink-0" />
                  <span className="text-gray-300 group-hover:text-white transition-colors">
                    {city}
                  </span>
                </div>
              ))}
            </div>

            {/* Corner decorations */}
            <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-[#00D4FF]/50" />
            <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-[#00D4FF]/50" />
            <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-[#00D4FF]/50" />
            <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-[#00D4FF]/50" />
          </div>

          {/* Bottom banner */}
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-center">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-[#00D4FF] animate-pulse" />
              <span className="text-gray-400">Rapid Response Available</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-white/20" />
            <p className="text-gray-500">
              Don't see your city? <a href="#contact" className="text-[#00D4FF] hover:underline">Contact us</a> – we cover all of Florida
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FloridaCoverage;
